import React, { useEffect, useState } from 'react'
import { DateCell, Button, useModal, theme } from '@fortressiq/fiq-ds'

import TrinityTable, { columnWidths } from 'components/TrinityTable'

import { useHeaderDispatch } from 'app/header/HeaderContext'

import ActionsMenu from './subComponents/ActionsMenu'
import DomainListForm from './subComponents/DomainListForm'

const sortKeyMap = {
  accessType: 'access_type',
  createdAt: 'created_at',
}

const createModalId = 'create-domain-list-form'

const modalConfig = {
  footer: false,
  style: { height: 'auto', width: '500px' },
  config: { interactWithKeyboard: false, destroyOnClose: true },
  headerStyle: { background: theme.white },
}

const DomainList = () => {
  const [reFetch, setReFetch] = useState(0)
  const { addModal, removeModal } = useModal()

  const handleReFetch = () => {
    setReFetch(reFetch + 1)
  }
  const headerDispatch = useHeaderDispatch()

  const columns = [
    {
      Header: 'Name',
      accessor: 'name',
    },
    {
      align: 'center',
      Header: 'Type',
      accessor: 'accessType',
      width: 50,
    },
    {
      align: 'right',
      Header: 'Created By',
      accessor: 'createdBy',
      disableSortBy: true,
      width: 150,
      Cell: ({ value: { firstName, lastName } }) => `${firstName} ${lastName}`,
    },
    {
      align: 'right',
      Header: 'Created At',
      accessor: 'createdAt',
      width: columnWidths.date,
      maxWidth: columnWidths.date,
      Cell: ({ value }) => <DateCell timestamp={value} />,
    },
    {
      Header: 'Actions',
      accessor: 'actions',
      align: 'center',
      disableSortBy: true,
      width: 30,
      maxWidth: columnWidths.actionMenu,
      Cell: ({ row: { original } }) => (
        <ActionsMenu
          handleReFetch={handleReFetch}
          domainList={original}
          modalConfig={modalConfig}
          isInUse={original.observers?.length !== 0}
        />
      ),
    },
  ]

  useEffect(() => {
    headerDispatch({
      type: 'set',
      title: 'Manage Domain List',
      heading: 'Manage Domain List',
    })

    return () => {
      headerDispatch({
        type: 'clear',
      })
    }
  }, [headerDispatch])

  return (
    <TrinityTable
      toolbarActions={[
        <Button
          type='secondary'
          key={createModalId}
          onClick={() =>
            addModal({
              children: <DomainListForm handleReFetch={handleReFetch} removeModal={() => removeModal(createModalId)} />,
              header: 'Create List',
              id: createModalId,
              ...modalConfig,
            })
          }
        >
          Create List
        </Button>,
      ]}
      reFetch={reFetch}
      sortKeyMap={sortKeyMap}
      params={{ category_type: 'url' }}
      tableId='domain-table'
      columns={columns}
      url='/allow_block_lists'
      dataKey='allowBlockList'
    />
  )
}

export default DomainList
